import type { Address } from "../locations/address";
import type { Order } from "./order";

const ordersForMyAddress = (orders: Order[], deliveryAddress?: Address) => {
    return orders.filter(
        f =>
            f.status.type !== "FULFILLED" &&
            f.status.type !== "REJECTED" &&
            f.delivery.deliveryMethodType === "HOME_DELIVERY" &&
            f.delivery.destination.address.addressRows[0] ===
                deliveryAddress?.addressRows[0] &&
            f.delivery.destination.address.zipCode === deliveryAddress?.zipCode,
    );
};

export { ordersForMyAddress };
